module.exports = __webpack_public_path__ + "media/codorniu.00fee9f9.mp4";